const dividerSvg = '/images/dividerOpacity.svg';

export const getDividerStyles = (isNotLastProduct: boolean) => {
  if (isNotLastProduct) {
    return {
      sx: {
        backgroundImage: `url(${dividerSvg})`,
        backgroundRepeat: 'repeat-x',
        backgroundSize: '6px 2px',
        backgroundPosition: 'top left',
        pos: 'relative',
        '&:before': {
          content: '""',
          pos: 'absolute',
          top: '0',
          right: '-10px',
          height: '2px',
          width: '12px',
          backgroundImage: `url(${dividerSvg})`,
          backgroundRepeat: 'repeat-x',
          backgroundSize: '6px 2px',
          backgroundPosition: 'top left',
        },
      },
    };
  }

  return {
    sx: {
      backgroundImage: `url(${dividerSvg})`,
      backgroundRepeat: 'repeat-x',
      backgroundSize: '6px 2px',
      backgroundPosition: 'top left',
    },
  };
};
